import { useContext } from 'react';
import { AuthContext, AUTH_REDIRECT_NEXT_KEY } from './authContextValue';

export { AUTH_REDIRECT_NEXT_KEY };

export const useAuth = () => useContext(AuthContext);
